// extracted by mini-css-extract-plugin
module.exports = {"footer":"style__footer__2SNqh","copyrightRow":"style__copyrightRow__BKgiU","address":"style__address__2CCxj"};